import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { useFetchDelightsQuery } from '../../delightApiSlice';
import { setDelightsData, setLoading, setError } from '../../delightSlice';
import { selectCurrentUser, selectCurrentUserEmpCode } from '../../../Auth/authSlice';
import CustomDialogBox from '../../../../common/CustomDialogBox';
import DelightsTable from './DelightsTable';
import SearchBar from './SearchBar';
import TabsFilter from './TabsFilter';
import { variants } from '../../../../variants/variants';
import RequestDialog from './RequestDialog';
import SkeletonTable from '../../../RnR/AdminRnR/SkeletonTable';
import { useTheme } from '@emotion/react';
import DelightsForm from '../DelightsApplication/DelightsForm';
import linkwaylogo from '../../../../assets/Linkway/LinkwayLogo.png';
import { Add, AddOutlined, HdrPlus, PlusOne } from '@mui/icons-material';
import { toggleSwipe } from '../../../Search/searchSlice';
import SwipeEdge from '../../../../common/SwipeEdge';
import GNXTLogo from '../../../../assets/GatewayLogo/G_NXTLogo.png';

const Delights = () => {
  const dispatch = useDispatch();
  const empCode = useSelector(selectCurrentUserEmpCode);
  const { data, error, isLoading } = useFetchDelightsQuery({ empCode: empCode });
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [searchText, setSearchText] = useState('');
  const [delightsDialogOpen, setDelightsDialogOpen] = useState(false);
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isMd = useMediaQuery(theme.breakpoints.down('md'));
  const isLg = useMediaQuery(theme.breakpoints.down('lg'));
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));

  useEffect(() => {
      // Component did mount logic here
  
      return () => {
        // Cleanup logic here
        dispatch(toggleSwipe({ value: false }))
        console.log('Component unmounted');
        // e.g., clear intervals, cancel subscriptions, etc.
      };
    }, []);

  const handleDelightsDialogOpen = () => {
    // setDelightsDialogOpen(true);
    dispatch(toggleSwipe({ value: true }));
    window['ReactNativeWebView'] &&
      window['ReactNativeWebView']?.postMessage(JSON.stringify({ type: 'swipe', value: true }));
  };

  const handleDelightsDialogClose = () => {
    // setDelightsDialogOpen(false);
  };

  const handleShowDetails = (request) => {
    setSelectedRequest(request);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  useEffect(() => {
    if (data) {
      dispatch(setDelightsData(data));
    }

    if (error) {
      dispatch(setError(error));
    }
    dispatch(setLoading(isLoading));
  }, [data, error, isLoading, dispatch]);

  // if (isLoading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  const filteredData = data?.filter((request) => {
    const statusMatches =
      tabValue === 0 || request.adminStatus?.toLowerCase() === ['pending', 'approved', 'rejected'][tabValue - 1];

    const searchTextMatches =
      searchText === '' ||
      request.outingType?.toLowerCase().includes(searchText.toLowerCase()) ||
      request.numberOfMembers?.toString().includes(searchText) ||
      new Date(request.dateRequested).toLocaleDateString().includes(searchText) ||
      request.adminStatus?.toLowerCase().includes(searchText.toLowerCase()) ||
      request.requestedBy?.toLowerCase().includes(searchText.toLowerCase()) ||
      request.requestType?.toLowerCase().includes(searchText.toLowerCase());

    return statusMatches && searchTextMatches;
  });

  return (
    <>
      <Grid
        item
        md={12}
        xs={12}
        sm={12}
        sx={{
          backgroundColor: 'white',
          borderRadius: '10px',
          border: 1,
          borderColor: 'divider',
          // height: 'calc(100vh - 135px)',
          height: '100%',
          overflow: 'hidden',
          // width: isSm ? '95vw' : '100%',
          width: '100%',
        }}
      >
        {isLoading ? (
          isSm ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                width: '100vw',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.5)', // Adjust the transparency level
                backdropFilter: 'blur(5px)', // Optional: Adds a blur effect to the background
              }}
            >
              {/* <Avatar variant={'rounded'} src={GNXTLogo} sx={{ height: 50, width: 50 }} /> */}
              <img src={GNXTLogo} style={{ height: 70, width: 150 }} />
              <Typography sx={{ mt: 2 }}>Loading...</Typography>
            </Box>
          ) : (
            <SkeletonTable />
          )
        ) : (
          <Box
            sx={{
              height: '100%',
              borderRadius: variants.boxRadius.NAVBAR,
              backgroundColor: 'text.wb',
              overflow: 'hidden',
              '& .MuiTableCell-footer': {
                p: 0,
                border: 0,
              },
            }}
          >
            <TabsFilter tabValue={tabValue} setTabValue={setTabValue} data={data} />
            <Grid sx={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
              <Grid item xs={12} sm={12} xl={12} md={12} sx={{}}>
                <SearchBar searchText={searchText} setSearchText={setSearchText} />
              </Grid>
              {/* {isSm && (
                <Grid item xs={12} sm={12} sx={{ marginRight: '1.5rem' }}>
                  <br />
                  <Grid
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      textAlign: 'center',
                      alignItems: 'center',
                      margin: '10px',
                    }}
                  >
                    <Typography sx={{ fontSize: '14px' }}>Planning for Team Dinner or outing?</Typography>
                    <Typography
                      variant="text"
                      size="small"
                      fullWidth
                      onClick={handleDelightsDialogOpen}
                      sx={{
                      display:'flex',
                        alignItems: 'center',
                        color: '#0A4FAC',
                        textDecoration: 'underlined',
                        fontSize: '14px',
                        textTransform: 'none',
                        // marginTop: '16px',
                      }}
                    >
                      <AddOutlined /> <span>Apply from here</span>
                    </Typography>
                  </Grid>
                </Grid>
              )} */}
              {isSm && <SwipeEdge
                height='70vh'
                title='Planning for Team Dinner or Outing?'
                content={
                  <>
                    <DelightsForm />
                  </>
                }
              />}
            </Grid>
            <DelightsTable data={filteredData} handleShowDetails={handleShowDetails} />
            <Dialog open={delightsDialogOpen} onClose={handleDelightsDialogClose} fullWidth maxWidth="lg">
              <DialogContent>
                <DelightsForm />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleDelightsDialogClose} color="primary">
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        )}
      </Grid>
      {selectedRequest && (
        <CustomDialogBox
          fullScreen={'fullScreen'}
          // height={'100%'}
          // width='60%'
          open={openDialog}
          handleClose={handleCloseDialog}
          title="Details"
          content={<RequestDialog selectedRequest={selectedRequest} />}
          actions={null}
        />
      )}
    </>
  );
};

export default Delights;
